module.exports = __webpack_public_path__ + "img/trial4-4.678dc556.png";